import { Box, Button, Heading, HStack, Link, Spinner, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { Follow, Share } from "react-twitter-widgets";
import { useAccount, useNetwork, useWaitForTransaction } from "wagmi";

import Subscriptions from "../components/wallet/Subscriptions";
import analyticsInstance from "../config/analytics";
import { NUM_CONFIRMATIONS } from "../config/constants";
import { getExplorerTxLink } from "../config/resolver";

function Success() {
  const txHash = useLocation()?.state?.txHash;
  const { error, status } = useWaitForTransaction({ hash: txHash, confirmations: NUM_CONFIRMATIONS + 2 });

  const { address } = useAccount();
  const { chain } = useNetwork();

  return (
    <Box
      display={{ base: "block", md: "flex" }}
      flexDir={{ md: "column" }}
      marginX="auto"
      maxW={{ base: "100%", md: "fit-content" }}
      px={{ base: "1em", md: "0" }}
      pt="2.5em"
      pb="10em"
    >
      <Box>
        {txHash && (
          <>
            <Heading size="2xl">
              BTFDCA-
              {status === "loading" && "ing!"}
              {status === "error" && "ick! 🫂"}
              {status === "success" && "ed! 🫂"}
            </Heading>
            <Text mt="2em" mb="3em">
              Here's your transaction:&nbsp;
              <Link href={getExplorerTxLink(chain, txHash)} isExternal>
                {txHash}
              </Link>
            </Text>
          </>
        )}

        {status === "loading" && (
          <Text>
            It's being processed 💈, this will take a moment!
            <Spinner as="span" ml="1em" />
          </Text>
        )}

        {status === "error" && (
          <>
            <Text>Wow, something's gone wrong! 💔</Text>
            <Text>Make sure you had enough to pay the gas fees, and reach out if this happens again.</Text>
            <Text>{error}</Text>

            <Button
              as="a"
              colorScheme="blue"
              size="lg"
              href={"mailto:help@btfdca.finance?subject=BTFDCA ERROR&body=" + txHash}
              variant="outline"
              borderRadius="0"
              border="3px solid"
              py="1.5em"
              px="3em"
            >
              📧 Tell me about the error
            </Button>
          </>
        )}

        {status === "success" && (
          <>
            <Text fontSize="2xl" fontWeight="bold">
              Congrats fren, welcome to the club! 🎆🥳
            </Text>

            <Text fontSize="xl" fontWeight="bold">
              What Now?
            </Text>

            <Box mt="2em">
              <Text fontWeight="bold">
                1. <u>Approve the distribution</u>, so that every &nbsp;
                <code>gm!</code>&nbsp; you can receive your target asset in your wallet!
              </Text>
              <HStack>
                <Text fontSize="xs">Ignore this if you've already done that.</Text>
                <Link fontSize="xs" href="/faq#subscriptions" isExternal>
                  Check the FAQ to understand why this is needed.
                </Link>
              </HStack>
              <Subscriptions account={address} hideTitle={true} hideDescription={true} />
            </Box>

            <Box mt="2em">
              <Text fontWeight="bold">
                2. <u>Tell your frens</u> good things about BTFDCA!
              </Text>

              <Box display="block" mt="1.5em">
                <Share
                  options={{
                    text: "BTFDCA is telling me to shill it to my dear followers. So check out @BTFDCA_finance",
                    size: "large",
                    dnt: false,
                  }}
                  url="https://btfdca.finance/"
                />
              </Box>
            </Box>

            <Box mt="3em">
              <Text fontWeight="bold">
                3. Give me some <u>feedback</u> about BTFDCA
              </Text>
              <Text>e.g. what do you like, dislike, things you'd like to see, etc</Text>
              <Button
                as="a"
                colorScheme="blue"
                href={"mailto:help@btfdca.finance?subject=Feedback&body=Hello BTFDCA,"}
                variant="outline"
                borderRadius="0"
                border="3px solid"
                py="1em"
                px="1.5em"
                mt="1em"
                onClick={() => analyticsInstance.track("FeedbackClicked")}
              >
                Feedy-feedy-back
              </Button>
            </Box>

            <Box mt="3em">
              <Text fontWeight="bold">
                4. <u>Follow</u> BTFDCA on twitter!
              </Text>
              <Text>CT is the best and you know it.</Text>
              <Box mt="1em">
                <Follow username="btfdca_finance" options={{ size: "large", showCount: "false" }} />
              </Box>
            </Box>

            <Box mt="3em">
              <Text fontWeight="bold">
                5. <u>Join</u> the BTFDCA community on discord!
              </Text>
              <Link href="https://discord.gg/AcgfRqukQt" isExternal display="block" my="1em">
                Wen roadmap? Wen token? Wen etc etc etc?
              </Link>
            </Box>

            <Box mt="10em">
              <Text fontWeight="bold">
                0. Unrelated - I built an NFT collection a while ago. <u>Check it out, and mint 1 or 2 or many!</u>
              </Text>
              <Link href="https://banner-nfts.com" isExternal display="block" my="1em">
                BAAAAAAAAAAANNNNNNNNNNER NFTs!
              </Link>
              <Text fontSize="xs">Yelled Bruce.</Text>
            </Box>
          </>
        )}

        {/* TODO: improve */}
        {/* {status === "idle" && <>Hey there, are you lost?</>} */}
      </Box>
    </Box>
  );
}

export default Success;
